export default "__VITE_ASSET__CgqfWwnK__"